import React from "react";
import {Typography} from "@mui/material";
import Grid from '@mui/material/Grid';

export default function PropertyGridDisplayComponent({label, text, component}) {

    return (
      <Grid container direction='row' justifyContent='flex-start' alignItems='center' mb={1}>
          <Grid size={4}><Typography variant='body2' fontWeight='bold' sx={{paddingLeft: '0.70rem'}}>{label}</Typography></Grid>
          <Grid size={8}>
              {!!text && <Typography variant='body2'>{text ? text : '--'}</Typography>}
              {!!component && component}
          </Grid>
      </Grid>
    );
}
